<template>
	<div class="ak1 ak">
		<div class="banner" id="banner1"><div class="banner-pro"></div></div>
		<div class="page-main-content">
			<div class="section2">
				<p class="text">{{text.second.text}}</p>
				<i class="airicon"></i>
			</div>
			<div class="section3">
				<img
					class="s3mobile-bg hidden"
					src="../assets/image/ak/easyset-mobile.jpg"
					alt=""
				/>
				<div class="desc-text easyplan">
					<h3 class="title">{{text.third[0].title}}</h3>
					<p class="text">{{text.third[0].text}}</p>
				</div>
				<div class="desc-text autonomous">
					<h3 class="title">{{text.third[1].title}}</h3>
					<p class="text">{{text.third[1].text}}</p>
				</div>
				<div class="redline rline">
					<div class="whiteline wline">
						<div class="dattedline dline"></div>
					</div>
				</div>
				<img
					class="redline-mobile rline hidden"
					src="../assets/image/ak/redline-mobile.png"
					alt=""
				/><i class="whiteline-mobile wline hidden"></i
				>
				<img
					v-if="$route.params.lang==='EN'"
					class="dline dattedline-mobile hidden"
					src="../assets/image/ak/airline-mobile-en.png"
					alt=""
				>
				<img
					v-else
					class="dline dattedline-mobile hidden"
					src="../assets/image/ak/airline-mobile.png"
					alt=""
				><img class="airplane" src="../assets/image/ak/airplane.png" alt="" />
			</div>
			<div class="section section4">
				<img
					class="section4bg-mobile hidden"
					src="../assets/image/ak/ak1yth-designbg.jpg"
					alt=""
				/>
				<div class="section-text">
					<h3 class="title">{{text.forth.title}}</h3>
					<p class="text">{{text.forth.text}}</p>
				</div>
			</div>
			<div class="section section5">
				<img
					v-if="$route.params.lang === 'EN'"
					class="section5bg-mobile hidden"
					src="../assets/image/ak/security-stability-mobile-en.png"
					alt=""
				/>
				<img
					v-else
					class="section5bg-mobile hidden"
					src="../assets/image/ak/security-stability-mobile.jpg"
					alt=""
				/>
				<div class="section-text">
					<h3 class="title">{{text.fifth.title}}</h3>
					<p class="text">{{text.fifth.text}}</p>
				</div>
			</div>
			<div class="section section6">
				<div class="section-text">
					<h3 class="title">{{text.sixth.title}}</h3>
					<p class="text">{{text.sixth.text}}</p>
				</div>
				<div class="interface">
					<i class="arrow1"></i>
					<p class="arrow1-text">{{text.sixth.tips[0]}}</p>
					<i class="arrow2"> </i
					><img
						v-if="$route.params.lang==='EN'"
						class="interface-mobile hidden"
						src="../assets/image/ak/interface-mobile-en.png"
						alt=""
					/><img
						v-else
						class="interface-mobile hidden"
						src="../assets/image/ak/interface-mobile.png"
						alt=""
					/>
					<p class="arrow2-text">{{text.sixth.tips[1]}}</p>
				</div>
			</div>
			<div class="section7">
				<h3 class="title">{{text.paramsTitle}}</h3>
				<div class="detaild-table">
					<div v-for="k in Object.keys(text.params)" :key="k">
						<p class="its-title">{{k}}</p>
						<ul class="its-table">
							<li v-for="(p, val) in Object.keys(text.params[k])" :key="val+p">
								<dl class="its-dl">
									<dt class="its-dt">{{p}}</dt>
									<dd class="its-dd">
										<ul>
											<template v-if="/object object/i.test(Object.prototype.toString.call(text.params[k][p]))">
												<li v-for="(value, index) in Object.keys(text.params[k][p])" :key="2+index">
													<span>{{text.params[k][p][value]}}</span>
													<p>{{value}}</p>
												</li>
											</template>
											<template v-if="/object string/i.test(Object.prototype.toString.call(text.params[k][p]))">
												<li>
													<span></span>
													<p>{{text.params[k][p]}}</p>
												</li>
											</template>
											<template v-if="/object array/i.test(Object.prototype.toString.call(text.params[k][p]))">
												<li>
													<span></span>
													<p>
														<em v-for="(item) in text.params[k][p]" :key="item">{{item}}<br></em>
													</p>
												</li>
											</template>
										</ul>
									</dd>
								</dl>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<foot></foot>
	</div>
</template>
<script>

import { init } from "@/js/ak.js";
import { AK1 } from '@/js/text.js';
import { mapState, mapMutations } from 'vuex';
import $ from 'jquery';

export default {
	name: 'ak1',
	metaInfo: {
		meta: [{
			name: 'keywords', 
			content: '固定翼,飞控,传感器,电力,测绘,农林,侦察,巡检,自主飞行,自动降落,航线飞行,GPS,气压传感器'
		},{
			name: 'description', 
			content: 'AK1是一款针对电动固定翼无人机打造的高性能、高可靠性、低成本飞控。AK1内置六自由度MEMS惯性传感器、三轴磁传感器、静压传感器、高灵敏度GPS接收机,实现了飞控的超小型一体化集成。AK1具有使用简单、重量轻、 维护成本低等特点，现已广泛用于电力、测绘、农林、侦察、巡检等领域。'
		}]
	},
	data() {
		return{}
	},
	components: {
		Foot: () => import("@/components/footer.vue"),
	},
	computed: {
		...mapState(['headerStyle']),
		text() {
			return this.$route.params.lang === 'CN' ? AK1.CN : AK1.EN
		}
	},
	methods: {
		...mapMutations(['setHeaderStyle'])
	},
	mounted() {
		init(this)
		this.setHeaderStyle({headerStyle: 'light'})
	},
	beforeDestroy() {
		window.onscroll = null
	}
}
</script>

<style lang="scss">
    @import '@/assets/css/ak';
</style>
